// Copyright (c) 2017 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../actions-list';
import {getDefaultState as getSpaDetailsDefaultState} from '../state';

const updateSpaTypes = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getSpaDetailsDefaultState().spaTypes, action) => {

    const actionTypes = {
        [actions.UPDATE_TABM_SPA_TYPES]: updateSpaTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tabm/spa-details/reducers/spa-types.js